import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDelete,
	bulkDeleteFail,
	bulkDeleteSuccess,
	constructEntityList,
	constructEntityListSuccess,
	createDatablocksFromEntities,
	createDatablocksFromEntitiesFail,
	createDatablocksFromEntitiesSuccess,
	deleteEntity,
	deleteEntityFail,
	deleteEntitySuccess,
	fetchEntityListFail,
	fetchEntityListSuccess,
	persistenceActionFinish,
	persistenceActionsAccepted,
	persistEntities,
	persistEntityStarted,
	persistEntityStopped,
	refreshEntityList,
	repersistEntities,
	repersistEntityStarted,
	repersistEntityStopped,
	trackAction,
	unpersistEntities,
	unpersistEntityStarted,
	unpersistEntityStopped,
	updateEntitiesFrameStatusSuccess,
} from './entity.actions';
import { EntityOriginalSliceState } from './entity.state';

export const entityOriginalReducer = createReducer<EntityOriginalSliceState>(
	new EntityOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(constructEntityList, refreshEntityList, (state) => state.setLoading(true)),
	on(fetchEntityListFail, (state) => state.setLoading(false)),
	on(constructEntityListSuccess, (state, action) =>
		state.setEntityList(action.entityList)
	),
	on(fetchEntityListSuccess, (state, action) =>
		state.setLoading(false).setEntityList(action.entityList)
	),
	on(
		persistEntityStarted,
		repersistEntityStarted,
		unpersistEntityStarted,
		(state, action) =>
			state.setEntityList(
				state.list.setJob(action.entityId, true, action.jobId)
			)
	),
	on(
		persistEntityStopped,
		unpersistEntityStopped,
		repersistEntityStopped,
		(state, action) =>
			state.setEntityList(
				state.list.setJob(action.entityId, false, action.jobId)
			)
	),
	on(trackAction, (state, action) =>
		state.setEntityList(state.list.setJobId(action.entityId, action.jobId))
	),
	on(persistenceActionFinish, (state, action) =>
		state.setEntityList(
			state.list
				.updatePersistenceInfo(action.entityId, action.persistenceInfo)
				.setJobId(action.entityId, null)
		)
	),
	on(updateEntitiesFrameStatusSuccess, (state, action) =>
		state.setEntityList(action.entityList)
	),
	on(deleteEntity, bulkDelete, (state) => state.setLoading(true)),
	on(deleteEntityFail, (state) => state.setLoading(false)),
	on(
		persistEntities,
		repersistEntities,
		unpersistEntities,
		deleteEntity,
		bulkDelete,
		createDatablocksFromEntities,
		(state) => state.setActionInProgress(true)
	),
	on(
		persistenceActionsAccepted,
		deleteEntitySuccess,
		deleteEntityFail,
		bulkDeleteSuccess,
		bulkDeleteFail,
		createDatablocksFromEntitiesSuccess,
		createDatablocksFromEntitiesFail,
		(state) => state.setActionInProgress(false)
	)
);
